import {
    Backdrop,
    Box,
    Checkbox,
    CircularProgress, FormControl,
    FormControlLabel,
    Grid,    
    InputLabel,    
    MenuItem,
    Select,
    TextField, Tooltip
} from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { RenderIf } from "../common/render-if/RenderIf";
import { useRegistrationStyles } from "./registrationStyles";
import { RegistrationLookups } from "../../services/medicationmanagement/userRegistration/RegistrationLookups";
import { errorMessages, useForm, UserRegistrationForm, Validator } from "./registrationFormHook";
import { PharmacistRegistrationForm } from "./PharmacistRegistrationForm";
import { FormControlContainer } from "./FormControlContainer";
import React, { useRef, useState } from "react";
import { registerUser } from "../../services/medicationmanagement/userRegistration/userRegistraitionService";
import { RegistrationSuccessful } from "./RegistrationSuccessful";
import { FlatButton } from "../common/FlatButton";
import { ApplicationDatePicker } from "./ApplicationDatePicker";
import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineSeparator
} from "@material-ui/lab";
import { TimelineItemProps } from "@material-ui/lab/TimelineItem/TimelineItem";
import { ReactComponent as OneIcon } from "../../images/1.svg";
import { ReactComponent as TwoIcon } from "../../images/2.svg";
import { ReactComponent as ThreeIcon } from "../../images/3.svg";
import { ReactComponent as FourIcon } from "../../images/4.svg";
import { ReactComponent as InfoIcon } from "../../images/info-icon.svg";
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'

const userTypeValidation = (userType: string | null, field?: string): Validator => {
    if (userType === 'Pharmacist') {
        var excludePharmacyFields = new Set(["hpiiNumber", "prescriberNumber", "ahpraRegistrationNumber", "practiceName", "medProviderNumber1", "medProviderValidFrom1"]);
        return checkRequiredFields(excludePharmacyFields, field);
    }
    else {
        var excludeNonPharmacyFields = new Set(["pharmacyName"])
        return checkRequiredFields(excludeNonPharmacyFields, field);
    }
};

const checkRequiredFields = (excludeFields: any, field?: string): Validator => {
    if (field && excludeFields.has(field))
        return _ => true;
    else
        return (val: string | null) => !!val;
}

const LeftAlignedTimelineItem = (props: TimelineItemProps) => {
    let classes = useRegistrationStyles();
    return <TimelineItem classes={{
        root: classes.timeLineItemRoot,
        missingOppositeContent: classes.missingOppositeContent
    }} {...props}>
        {props.children}
    </TimelineItem>
};
const WrappedCheckBox = (props: { register: (field: keyof UserRegistrationForm, value: string | null, validator?: Validator | 'Required') => any }) => {
    let modelRegistration = props.register("termsAcknowledged", false as any);
    let classes = useRegistrationStyles();
    const onAcknowledged = (e: any) => {
        let val = e.target.checked;
        modelRegistration.onChange({ target: { value: val } });
    }
    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={!!modelRegistration.value}
                    onChange={onAcknowledged}
                    name={modelRegistration.name}
                    color="primary"
                />
            }
            label={
                <div>
                    I have read and accept the Telstra Health <a target="_blank" href="https://www.telstrahealth.com/content/telstrahealth/en/privacy-policy.html">Privacy Policy</a>.
                    <span className={classes.requiredColor}> *</span>
                </div>           
                }
        />
    );
}

const theme = createTheme({
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: "12.64px",
                color: "#333333",
                backgroundColor: "#ffffff",
                borderRadius: "5px",
                border: "1px solid #666666",
                fontWeight: 400,
                lineHeight: "16px",
                textAlign: "center",
                fontFamily: "Source Sans Pro",
                maxWidth:"220px"
            },
            arrow: {
                "&:before": {
                    border: "1px solid #666666"
                },
                color: "#ffffff"
            },
        }
    }
});

export const RegistrationForm = (props: { lookUps: RegistrationLookups }) => {

    let classes = useRegistrationStyles();
    let formRef = useRef(null);
    let { model, register, errors, handleSubmit } = useForm<UserRegistrationForm>(formRef);
    let [submitState, changeSubmitState] = useState<"Submitted" | "Error" | "Submitting" | "None">("None");
    let requiredMessage = errorMessages.get('Required');

    if (submitState === "Submitted") {
        return <RegistrationSuccessful />;
    }

    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <Box>
                <Box className={classes.titleBig}>
                    MedPoint registration
                </Box>


                <form className={classes.form} ref={formRef} noValidate onSubmit={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSubmit(m => {
                        changeSubmitState("Submitting");
                        let formattedData = {
                            ...m,
                            phoneNumber: `${m.phoneArea} ${m.phoneLocal}`
                        };
                        registerUser(formattedData)
                            .then(_ => changeSubmitState("Submitted"))
                            .catch(_ => changeSubmitState("Error"));
                    });
                }}>
                    <Timeline classes={{
                        root: classes.timelineRoot
                    }}>
                        <LeftAlignedTimelineItem>
                            <TimelineSeparator>
                                <TimelineDot classes={{
                                    defaultPrimary: classes.timelineDot
                                }} color="primary">
                                    <OneIcon />
                                </TimelineDot>
                                <TimelineConnector classes={{
                                    root: classes.timelineConnector
                                }} />
                            </TimelineSeparator>
                            <TimelineContent className={classes.timelineContent}>
                                <Box className={classes.timelineTitle}>
                                    User details
                                </Box>
                                <PharmacistRegistrationForm lookUps={props.lookUps} errors={errors} registerControl={register} />
                            </TimelineContent>
                        </LeftAlignedTimelineItem>
                        <RenderIf if={model.userType === 'Doctor' || model.userType === 'Other'}>
                            <>
                                <LeftAlignedTimelineItem>
                                    <TimelineSeparator>
                                        <TimelineDot color="primary" classes={{
                                            defaultPrimary: classes.timelineDot
                                        }}>
                                            <TwoIcon />
                                        </TimelineDot>
                                        <TimelineConnector classes={{
                                            root: classes.timelineConnector
                                        }} />
                                    </TimelineSeparator>
                                    <TimelineContent className={classes.timelineContent}>
                                        <Box className={classes.timelineTitle}>
                                            Prescriber details
                                        </Box>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel className="label" shrink htmlFor="designation">
                                                Qualification/Specialist qualification 
                                                <MuiThemeProvider theme={createTheme()}>
                                                    <>
                                                        <MuiThemeProvider theme={theme}>
                                                            <Tooltip arrow title="Qualification/Specialist qualification information is required in the ACT to generate electronic prescription." placement={'bottom'} >
                                                                <InfoIcon className={classes.tooltipIcon}></InfoIcon>
                                                            </Tooltip>
                                                        </MuiThemeProvider>
                                                    </>
                                                </MuiThemeProvider>
                                            </InputLabel>
                                            <TextField
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                {...register('designation', '')}
                                            />
                                        </FormControl>
                                        <FormControlContainer hasError={() => errors.hpiiNumber} label="HPI-I number" errorMessage={requiredMessage} id="hpiiNumber">
                                            <TextField
                                                required
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                {...register('hpiiNumber', '', userTypeValidation(model.userType, 'hpiiNumber'))}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControlContainer>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                <FormControlContainer hasError={() => errors.prescriberNumber} label="Prescriber number" errorMessage={requiredMessage} id="prescriberNumber">
                                                    <TextField
                                                        required
                                                        placeholder=""
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        {...register('prescriberNumber', '', userTypeValidation(model.userType, 'prescriberNumber'))}
                                                    />
                                                </FormControlContainer>

                                            </Grid>
                                            <Grid item>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel className="label" shrink>
                                                        Prescriber expiry
                                                    </InputLabel>
                                                    <ApplicationDatePicker
                                                        {...register('prescriberExpiry', null)}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                <FormControlContainer hasError={() => errors.ahpraRegistrationNumber} label="AHPRA registration number" id="ahpraRegistrationNumber" errorMessage={requiredMessage}>
                                                    <TextField
                                                        required
                                                        placeholder=""
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        {...register('ahpraRegistrationNumber', '', userTypeValidation(model.userType, 'ahpraRegistrationNumber'))}
                                                    />
                                                </FormControlContainer>

                                            </Grid>
                                            <Grid item>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel className="label" shrink>
                                                        AHPRA expiry
                                                    </InputLabel>
                                                    <ApplicationDatePicker
                                                        {...register('ahpraExpiry', null)}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </TimelineContent>
                                </LeftAlignedTimelineItem>
                                <LeftAlignedTimelineItem>
                                    <TimelineSeparator>
                                        <TimelineDot color="primary" classes={{
                                            defaultPrimary: classes.timelineDot
                                        }}>
                                            <ThreeIcon />
                                        </TimelineDot>
                                        <TimelineConnector classes={{
                                            root: classes.timelineConnector
                                        }} />
                                    </TimelineSeparator>
                                    <TimelineContent className={classes.timelineContent}>
                                        <Box className={classes.timelineTitle}>
                                            Practice details
                                        </Box>
                                        <FormControlContainer hasError={() => errors.practiceName} label="Practice name" id="practiceName" errorMessage={requiredMessage}>
                                            <TextField
                                                required
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                {...register('practiceName', '', userTypeValidation(model.userType, 'practiceName'))}
                                            />
                                        </FormControlContainer>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel className="label" shrink htmlFor="hpioNumber">
                                                HPI-O number
                                            </InputLabel>
                                            <TextField
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                {...register('hpioNumber', '')}
                                            />
                                        </FormControl>
                                        <FormControlContainer label="Street address" id="streetAddress" hasError={() => errors.streetAddress} errorMessage={requiredMessage}>
                                            <TextField
                                                required
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                {...register('streetAddress', '', userTypeValidation(model.userType))}
                                            />
                                        </FormControlContainer>
                                        <FormControlContainer hasError={() => errors.city} label="City" id="City" errorMessage={requiredMessage}>
                                            <TextField
                                                required
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                {...register('city', '', userTypeValidation(model.userType))}
                                            />
                                        </FormControlContainer>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                <FormControlContainer hasError={() => errors.postCode} label="Postcode" id="postcode" errorMessage={requiredMessage}>
                                                    <TextField
                                                        id="postCode"
                                                        placeholder=""
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        {...register('postCode', '', userTypeValidation(model.userType))}
                                                    />
                                                </FormControlContainer>

                                            </Grid>
                                            <Grid item>
                                                <FormControlContainer hasError={() => errors.state} label="State" id="state" errorMessage={requiredMessage}>
                                                    <Select
                                                        fullWidth
                                                        {...register('state', '', userTypeValidation(model.userType))}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        {props.lookUps.states.map(x => <MenuItem key={x.code} value={x.code || ''}>{x.name}</MenuItem>)}
                                                    </Select>
                                                </FormControlContainer>
                                            </Grid>
                                        </Grid>
                                    </TimelineContent>
                                </LeftAlignedTimelineItem>

                                <LeftAlignedTimelineItem>
                                    <TimelineSeparator>
                                        <TimelineDot color="primary" classes={{
                                            defaultPrimary: classes.timelineDot
                                        }}>
                                            <FourIcon />
                                        </TimelineDot>
                                        <TimelineConnector classes={{
                                            root: classes.timelineConnector
                                        }} />
                                    </TimelineSeparator>
                                    <TimelineContent className={classes.timelineContent}>
                                        <Box className={classes.timelineTitle}>
                                            Medicare provider details
                                        </Box>
                                        <FormControlContainer label="Medicare provider number" errorMessage={requiredMessage} hasError={() => errors.medProviderNumber1} id="medicareProviderNumber1">
                                            <TextField
                                                required
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                {...register('medProviderNumber1', '', userTypeValidation(model.userType, 'medProviderNumber1'))}
                                            />
                                        </FormControlContainer>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                <FormControlContainer label="Medicare provider valid from" errorMessage={requiredMessage} hasError={() => errors.medProviderValidFrom1} id="validFrom1">
                                                    <ApplicationDatePicker
                                                        {...register('medProviderValidFrom1', null, userTypeValidation(model.userType, 'medProviderValidFrom1'))}
                                                    />
                                                </FormControlContainer>

                                            </Grid>
                                            <Grid item>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel className="label" shrink htmlFor="validFrom2">
                                                        Medicare provider valid to
                                                    </InputLabel>
                                                    <ApplicationDatePicker
                                                        {...register('medProviderValidTo1', null)}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        {/*start*/}
                                        <FormControl className={classes.formControl}>
                                            <InputLabel className="label" shrink htmlFor="medicareProviderNumber2">
                                                Additional Medicare provider number (if required)
                                            </InputLabel>
                                            <TextField
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                {...register('medProviderNumber2', '')}
                                            />
                                        </FormControl>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel className="label" shrink htmlFor="validFrom2">
                                                        Medicare provider valid from
                                                    </InputLabel>
                                                    <ApplicationDatePicker
                                                        {...register('medProviderValidFrom2', null)}
                                                    />
                                                </FormControl>

                                            </Grid>
                                            <Grid item>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel className="label" shrink htmlFor="validTo2">
                                                        Medicare provider valid to
                                                    </InputLabel>
                                                    <ApplicationDatePicker
                                                        {...register('medProviderValidTo2', null)}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel className="label" shrink htmlFor="medicareProviderNumber3">
                                                Additional Medicare provider number (if required)
                                            </InputLabel>
                                            <TextField
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                {...register('medProviderNumber3', '')}
                                            />
                                        </FormControl>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel className="label" shrink htmlFor="validFrom3">
                                                        Medicare provider valid from
                                                    </InputLabel>
                                                    <ApplicationDatePicker
                                                        {...register('medProviderValidFrom3', null)}
                                                    />
                                                </FormControl>

                                            </Grid>
                                            <Grid item>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel className="label" shrink htmlFor="validTo3">
                                                        Medicare provider valid to
                                                    </InputLabel>
                                                    <ApplicationDatePicker
                                                        {...register('medProviderValidTo3', null)}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel className="label" shrink htmlFor="medicareProviderNumber4">
                                                Additional Medicare provider number (if required)
                                            </InputLabel>
                                            <TextField
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                {...register('medProviderNumber4', '')}
                                            />
                                        </FormControl>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel className="label" shrink htmlFor="validFrom4">
                                                        Medicare provider valid from
                                                    </InputLabel>
                                                    <ApplicationDatePicker
                                                        {...register('medProviderValidFrom4', null)}
                                                    />
                                                </FormControl>

                                            </Grid>
                                            <Grid item>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel className="label" shrink htmlFor="validTo4">
                                                        Medicare provider valid to
                                                    </InputLabel>
                                                    <ApplicationDatePicker
                                                        {...register('medProviderValidTo4', null)}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel className="label" shrink htmlFor="medicareProviderNumber5">
                                                Additional Medicare provider number (if required)
                                            </InputLabel>
                                            <TextField
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                {...register('medProviderNumber5', '')}
                                            />
                                        </FormControl>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel className="label" shrink htmlFor="validFrom5">
                                                        Medicare provider valid from
                                                    </InputLabel>

                                                    <ApplicationDatePicker
                                                        {...register('medProviderValidFrom5', null)}
                                                    />
                                                </FormControl>

                                            </Grid>
                                            <Grid item>
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel className="label" shrink htmlFor="validTo5">
                                                        Medicare provider valid to
                                                    </InputLabel>
                                                    <ApplicationDatePicker
                                                        {...register('medProviderValidTo5', null)}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </TimelineContent>
                                </LeftAlignedTimelineItem>
                            </>
                        </RenderIf>

                        <RenderIf if={model.userType === 'Pharmacist'}>
                            <>
                                <LeftAlignedTimelineItem>
                                    <TimelineSeparator>
                                        <TimelineDot color="primary" classes={{
                                            defaultPrimary: classes.timelineDot
                                        }}>
                                            <TwoIcon />
                                        </TimelineDot>
                                        <TimelineConnector classes={{
                                            root: classes.timelineConnector
                                        }} />
                                    </TimelineSeparator>
                                    <TimelineContent className={classes.timelineContent}>
                                        <Box className={classes.timelineTitle}>
                                            Pharmacy details
                                        </Box>
                                        <FormControlContainer hasError={() => errors.pharmacyName} label="Pharmacy  name" id="pharmacyName" errorMessage={requiredMessage}>
                                            <TextField
                                                required
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                {...register('pharmacyName', '', userTypeValidation(model.userType, 'pharmacyName'))}
                                            />
                                        </FormControlContainer>
                                        <FormControlContainer label="Street address" id="streetAddress" hasError={() => errors.streetAddress} errorMessage={requiredMessage}>
                                            <TextField
                                                required
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                {...register('streetAddress', '', userTypeValidation(model.userType))}
                                            />
                                        </FormControlContainer>
                                        <FormControlContainer hasError={() => errors.city} label="City" id="City" errorMessage={requiredMessage}>
                                            <TextField
                                                required
                                                placeholder=""
                                                fullWidth
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                {...register('city', '', userTypeValidation(model.userType))}
                                            />
                                        </FormControlContainer>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                <FormControlContainer hasError={() => errors.postCode} label="Postcode" id="postcode" errorMessage={requiredMessage}>
                                                    <TextField
                                                        id="postCode"
                                                        placeholder=""
                                                        fullWidth
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        {...register('postCode', '', userTypeValidation(model.userType))}
                                                    />
                                                </FormControlContainer>

                                            </Grid>
                                            <Grid item>
                                                <FormControlContainer hasError={() => errors.state} label="State" id="state" errorMessage={requiredMessage}>
                                                    <Select
                                                        fullWidth
                                                        {...register('state', '', userTypeValidation(model.userType))}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        {props.lookUps.states.map(x => <MenuItem key={x.code} value={x.code || ''}>{x.name}</MenuItem>)}
                                                    </Select>
                                                </FormControlContainer>
                                            </Grid>
                                        </Grid>
                                    </TimelineContent>
                                </LeftAlignedTimelineItem>
                            </>
                        </RenderIf>

                    </Timeline>

                    <FormControlContainer hasError={() => false} id="policy" label="" errorMessage="">
                        <Box className={classes.disclaimer}>
                            <WrappedCheckBox register={register} />
                        </Box>

                    </FormControlContainer>
                    <FlatButton
                        kind="primary"
                        isDisabled={!model.termsAcknowledged}
                        type="submit"
                        css={{
                            width: 168
                        }}
                    >
                        Submit
                    </FlatButton>
                </form>
            </Box>
            <Backdrop className={classes.backdrop} open={submitState === "Submitting"}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </MuiPickersUtilsProvider>
    );
}